// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_ConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /subaccounts/anticipations/config/{subaccount_id}
 *
 * Returns the local (persisted) anticipation config plus the upstream
 * provider's anticipation-config blob. The dados is a single typed object:
 *
 *   - subaccount_id        ← (int) URL path param
 *   - local_config         ← decoded `subaccounts.anticipation_config` JSON.
 *                            Same persisted shape the update_config endpoint
 *                            writes, so it reuses the sibling LocalConfig Row.
 *                            Null when the subaccount has no stored config.
 *   - provider_config      ← PaymentProviderInterface::getAnticipationConfig()
 *                            (ASAAS GET /anticipations/configurations). Same
 *                            configuration object the PUT path returns, so it
 *                            reuses the sibling ProviderResult Row. Best-effort:
 *                            null on provider failure / unreachable provider.
 *   - supports_anticipation ← provider->supportsAnticipation() (always true on
 *                            the success path; the controller throws otherwise)
 *   - supports_limits      ← provider->supportsAnticipationLimits()
 *
 * Probe-confirmed (PROBE_CAPTURE_RESPONSE, local-config-set path):
 *   {"subaccount_id":1,"local_config":{"enabled":true,"updated_at":"2026-05-30 02:35:28",
 *    "updated_by":"b17b…"},"provider_config":null,"supports_anticipation":true,
 *    "supports_limits":true}
 *
 * @see anticipations.php::config()
 */
import type { SubaccountsAnticipations_UpdateConfigLocalConfigRow } from './SubaccountsAnticipations_UpdateConfigLocalConfigRow'
import type { SubaccountsAnticipations_UpdateConfigProviderResultRow } from './SubaccountsAnticipations_UpdateConfigProviderResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_ConfigResponseDados {
subaccount_id: number
supports_anticipation: boolean
supports_limits: boolean
local_config?: SubaccountsAnticipations_UpdateConfigLocalConfigRow
provider_config?: SubaccountsAnticipations_UpdateConfigProviderResultRow
}

export type SubaccountsAnticipations_ConfigResponse = ApiResponse<SubaccountsAnticipations_ConfigResponseDados>;

registerResponseContract('SubaccountsAnticipations_ConfigResponse', {
  subaccount_id:         { type: 'number',  required: true },
  supports_anticipation: { type: 'boolean', required: true },
  supports_limits:       { type: 'boolean', required: true },
  local_config: {
    type: 'object',
    required: false,
    fields: {
      enabled:          { type: 'boolean', required: false },
      auto_credit_card: { type: 'boolean', required: false },
      min_amount:       { type: 'number',  required: false },
      updated_at:       { type: 'string',  required: false },
      updated_by:       { type: 'string',  required: false },
    },
  },
  provider_config: {
    type: 'object',
    required: false,
    fields: {
      creditCardAutomaticEnabled: { type: 'boolean', required: false },
    },
  },
})
